import { format, formatDistanceToNow, isToday, isYesterday } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const formatDate = (date: Date | string, pattern = "dd 'de' MMM, yyyy"): string => {
  const d = typeof date === 'string' ? new Date(date) : date;
  return format(d, pattern, { locale: ptBR });
};

export const formatTime = (date: Date | string): string => {
  const d = typeof date === 'string' ? new Date(date) : date;
  return format(d, 'HH:mm', { locale: ptBR });
};

export const formatRelative = (date: Date | string): string => {
  const d = typeof date === 'string' ? new Date(date) : date;
  if (isToday(d)) return formatTime(d);
  if (isYesterday(d)) return 'Ontem';
  return formatDistanceToNow(d, { addSuffix: true, locale: ptBR });
};

export const formatInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  return (first + last).toUpperCase();
};
